export const FILES_ENDPOINT = '/files';
